/* CY CART controller (2026-10-05) — the side cart (sections/cy-cart.liquid) and the cart page (sections/cy-main-cart.liquid).
   Every change is ONE request to the Ajax Cart API with `sections` (Section Rendering API) for every cart root on the page;
   the answer's HTML refreshes only the [data-cyc-region] parts (checkout + express pay are never re-rendered). Requests
   run one at a time (a queue); quantity clicks are optimistic and debounced; a remove leaves "Removed … · Undo" for 6s;
   codes use /cart/update.js { discount } (all kept codes are sent, the new one checked by `applicable`). The drawer is a
   modal <dialog>: focus to its title, Tab stays inside, Esc / backdrop / × close, focus returns; the header cart icon
   opens it; Shopify.actions.openCart (where present) points to it. window.cyCart.refresh(open) is what the product page
   and the product cards call after their own cart/add.js. */
(function () {
  'use strict';
  if (window.cyCart) return;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CALM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var q = Promise.resolve();                       // the request queue
  var opener = null, addedTimer = 0, toastTimer = 0;

  function roots() { return Array.prototype.slice.call(document.querySelectorAll('[data-cyc-root]')); }
  function drawerRoot() { return document.querySelector('[data-cyc-root="drawer"]'); }
  function dialog() { var r = drawerRoot(); return r && r.querySelector('dialog'); }
  function ids() { return roots().map(function (r) { return r.getAttribute('data-section-id'); }).filter(Boolean); }

  /* ---------- rendering ---------- */
  function lineState(scope) {
    var o = {};
    if (scope) scope.querySelectorAll('[data-cyc-line]').forEach(function (li) { o[li.getAttribute('data-key')] = { q: +li.getAttribute('data-qty'), t: li.getAttribute('data-title') }; });
    return o;
  }
  function render(sections) {
    if (!sections) return;
    var count = null;
    roots().forEach(function (r) {
      var html = sections[r.getAttribute('data-section-id')];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cyc-root]');
      if (!fresh) return;
      r.querySelectorAll('[data-cyc-region]').forEach(function (reg) {
        var f = fresh.querySelector('[data-cyc-region="' + reg.getAttribute('data-cyc-region') + '"]');
        if (f && f.innerHTML !== reg.innerHTML) reg.innerHTML = f.innerHTML;
        if (f && f.hasAttribute('href') && f.getAttribute('href') !== reg.getAttribute('href')) reg.setAttribute('href', f.getAttribute('href'));
      });
      r.setAttribute('data-count', fresh.getAttribute('data-count'));
      r.setAttribute('data-total', fresh.getAttribute('data-total'));
      count = +fresh.getAttribute('data-count');
      var foot = r.querySelector('[data-cyc-foot]'); if (foot) foot.hidden = count === 0;
      var pay = r.querySelector('.cyc-page__pay'); if (pay) pay.hidden = count === 0;
      var dock = r.querySelector('[data-cyc-dock]'); if (dock && count === 0) dock.hidden = true;
    });
    if (count !== null) setCount(count);
    watchDock();
  }
  function setCount(n) {
    document.querySelectorAll('hdt-cart-count').forEach(function (el) { el.textContent = n; });
    document.querySelectorAll('[ref="hdt-cart"]').forEach(function (el) { el.setAttribute('data-count', n); });
    document.dispatchEvent(new CustomEvent('cy:cart:count', { detail: { item_count: n } }));
  }
  function say(txt) { roots().forEach(function (r) { var l = r.querySelector('[data-cyc-live]'); if (l) { l.textContent = ''; setTimeout(function () { l.textContent = txt; }, 30); } }); }
  function activeRoot(el) { return (el && el.closest && el.closest('[data-cyc-root]')) || (dialog() && dialog().open ? drawerRoot() : document.querySelector('[data-cyc-root="page"]')) || drawerRoot(); }

  /* ---------- requests ---------- */
  function post(path, body) {
    body.sections = ids().join(',');
    body.sections_url = location.pathname;
    var run = function () {
      roots().forEach(function (r) { r.classList.add('is-busy'); });
      return fetch(ROOT + path, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (res) { return res.json().then(function (j) { if (!res.ok || j.status) { var e = new Error(j.description || j.message || 'Cart error'); e.data = j; throw e; } return j; }); })
        .finally(function () { roots().forEach(function (r) { r.classList.remove('is-busy'); }); });
    };
    var p = q.then(run, run); q = p.catch(function () {}); return p;
  }
  function refetch() {
    var run = function () { return fetch(ROOT + '?sections=' + encodeURIComponent(ids().join(',')), { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(render); };
    var p = q.then(run, run); q = p.catch(function () {}); return p;
  }

  /* ---------- the drawer ---------- */
  function trapTab(e) {
    var d = dialog(); if (!d || !d.open || e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(d.querySelectorAll('a[href], button:not([disabled]), input, textarea, summary, [tabindex]:not([tabindex="-1"])'), function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function open(trigger) {
    var d = dialog(); if (!d) { location.href = ROOT + 'cart'; return; }
    if (d.open) return;
    opener = trigger || document.activeElement;
    d.showModal();
    document.documentElement.classList.add('cyc-lock');
    var t = d.querySelector('#CyCartTitle'); if (t) t.focus({ preventScroll: true });
    requestAnimationFrame(function () { d.classList.add('is-in'); });
    document.dispatchEvent(new CustomEvent('shopify:cart:view', { bubbles: true }));
  }
  function close() {
    var d = dialog(); if (!d || !d.open) return;
    d.classList.remove('is-in');
    var done = function () { d.close(); };
    if (CALM) done(); else setTimeout(done, 260);
  }
  function onClosed() {
    document.documentElement.classList.remove('cyc-lock');
    if (opener && opener.focus) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
    opener = null;
  }

  function announceAdded(key, title) {
    var r = drawerRoot(); if (!r) return;
    var strip = r.querySelector('[data-cyc-added]'), txt = strip && strip.querySelector('[data-cyc-added-text]');
    if (strip && txt) {
      if (!strip.dataset.label) strip.dataset.label = txt.textContent.trim();
      txt.textContent = strip.dataset.label + ': ';
      var b = document.createElement('b'); b.textContent = title; txt.appendChild(b);
      strip.hidden = false; clearTimeout(addedTimer); addedTimer = setTimeout(function () { strip.hidden = true; }, 4000);
    }
    roots().forEach(function (root) {
      var li = root.querySelector('[data-cyc-line][data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
      if (li) { li.classList.remove('is-new'); void li.offsetWidth; li.classList.add('is-new'); }
    });
    say(title + ' added to your cart');
  }

  /* refresh after someone else added (product page, cards): one request; the line that grew is named */
  function refresh(openIt) {
    var before = lineState(drawerRoot() || document);
    return refetch().then(function () {
      var after = lineState(drawerRoot() || document), key = null;
      Object.keys(after).forEach(function (k) { if (!key && after[k].q > ((before[k] || {}).q || 0)) key = k; });
      if (openIt) open();
      if (key) announceAdded(key, after[key].t);
    });
  }
  function add(items, openIt) {
    var before = lineState(drawerRoot() || document);
    return post('cart/add.js', { items: items }).then(function (res) {
      render(res.sections);
      var after = lineState(drawerRoot() || document), key = null;
      Object.keys(after).forEach(function (k) { if (!key && after[k].q > ((before[k] || {}).q || 0)) key = k; });
      if (openIt !== false && drawerRoot() && !document.querySelector('[data-cyc-root="page"]')) open();
      if (key) announceAdded(key, after[key].t);
      return res;
    });
  }

  /* ---------- quantities, remove, undo ---------- */
  var pending = {}, pendingFn = {};
  function setQty(li, qty) {
    var key = li.getAttribute('data-key'), was = +li.getAttribute('data-qty'), root = activeRoot(li);
    var input = li.querySelector('[data-cyc-qty]'); if (input) input.value = qty;
    li.classList.add('is-pending');
    clearTimeout(pending[key]);
    var fire = function () {
      delete pending[key]; delete pendingFn[key];
      var undo = qty === 0 ? { id: +li.getAttribute('data-variant'), quantity: was, properties: li.getAttribute('data-props') ? JSON.parse(li.getAttribute('data-props')) : undefined, title: li.getAttribute('data-title') } : null;
      if (qty === 0 && !CALM) li.classList.add('is-leaving');
      post('cart/change.js', { id: key, quantity: qty }).then(function (cart) {
        render(cart.sections);
        if (undo) toast(root, undo);
        else {
          var got = (cart.items || []).filter(function (i) { return i.key === key; })[0];
          if (got && got.quantity < qty) { var nl = findLine(key); if (nl) lineErr(nl, 'Only ' + got.quantity + ' available'); }
          say('Quantity updated to ' + qty);
        }
      }).catch(function (e) {
        li.classList.remove('is-pending', 'is-leaving');
        if (input) input.value = was;
        lineErr(li, (e.data && e.data.description) || 'That didn’t work. Please try again.');
      });
    };
    pendingFn[key] = fire;
    pending[key] = setTimeout(fire, 320);
  }
  /* every quantity change still waiting goes now; resolves when the cart has caught up (View cart / Checkout wait for it) */
  function settle() {
    Object.keys(pendingFn).forEach(function (k) { clearTimeout(pending[k]); pendingFn[k](); });
    return q.then(function () {}, function () {});
  }
  function findLine(key) { var f = null; roots().forEach(function (r) { f = f || r.querySelector('[data-cyc-line][data-key="' + key + '"]'); }); return f; }
  function lineErr(li, msg) { var e = li.querySelector('[data-cyc-err]'); if (e) { e.textContent = msg; e.hidden = false; } }
  function toast(root, undo) {
    var t = root && root.querySelector('[data-cyc-toast]'); if (!t) return;
    t.innerHTML = '';
    var s = document.createElement('span'); s.textContent = 'Removed ' + undo.title; t.appendChild(s);
    var b = document.createElement('button'); b.type = 'button'; b.textContent = 'Undo'; b.className = 'cyc__undo';
    b.addEventListener('click', function () {
      t.hidden = true;
      var it = { id: undo.id, quantity: undo.quantity }; if (undo.properties) it.properties = undo.properties;
      add([it], false).then(function () { say(undo.title + ' is back in your cart'); });
    });
    var dlg = t.closest('dialog'), ft = dlg && dlg.querySelector('[data-cyc-foot]');
    if (dlg && ft) dlg.style.setProperty('--cyc-foot-h', ft.offsetHeight + 'px');   /* sit just above the side cart's footer */
    t.appendChild(b); t.hidden = false;
    say('Removed ' + undo.title + '. Undo available.');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.hidden = true; }, 6000);
  }

  /* ---------- discount codes ---------- */
  function codesNow(root) {
    var c = []; (root || document).querySelectorAll('[data-cyc-code-remove]').forEach(function (b) { var v = b.getAttribute('data-cyc-code-remove'); if (c.indexOf(v) < 0) c.push(v); });
    return c;
  }
  function codeMsg(root, txt, bad) { var m = root && root.querySelector('[data-cyc-code-msg]'); if (m) { m.textContent = txt; m.hidden = !txt; m.classList.toggle('is-bad', !!bad); } }
  function applyCode(root) {
    var input = root.querySelector('[data-cyc-code-input]'); if (!input) return;
    var code = input.value.trim(); if (!code) { input.focus(); return; }
    var keep = codesNow(root);
    if (keep.map(function (x) { return x.toLowerCase(); }).indexOf(code.toLowerCase()) >= 0) { codeMsg(root, 'That code is already applied.', false); return; }
    post('cart/update.js', { discount: keep.concat(code).join(',') }).then(function (cart) {
      var hit = (cart.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
      if (!hit || !hit.applicable) {
        return post('cart/update.js', { discount: keep.join(',') }).then(function (c2) {
          render(c2.sections); codeMsg(root, 'This code doesn’t apply to your cart.', true);
          var fold = root.querySelector('[data-cyc-code-fold]'); if (fold) fold.open = true;
        });
      }
      render(cart.sections); codeMsg(root, '', false); input.value = ''; say('Code ' + code + ' applied');
    }).catch(function () { codeMsg(root, 'Couldn’t check that code. Please try again.', true); });
  }
  function removeCode(root, code) {
    var keep = codesNow(root).filter(function (c) { return c !== code; });
    post('cart/update.js', { discount: keep.join(',') }).then(function (cart) { render(cart.sections); say('Code ' + code + ' removed'); });
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    /* the header / toolbar cart icon opens the drawer */
    var cartLink = t.closest && t.closest('a[aria-controls="CartDrawer"], .hdt-site-nav_cart a, [data-cyc-open]');
    if (cartLink && dialog() && !document.querySelector('[data-cyc-root="page"]')) { e.preventDefault(); e.stopImmediatePropagation(); open(cartLink); return; }
    var root = t.closest && t.closest('[data-cyc-root]'); if (!root) return;
    if (t.closest('[data-cyc-close]')) { close(); return; }
    var d = dialog(); if (d && t === d) { close(); return; }
    if (t.closest('[data-cyc-close-link]') && d && d.open && t.closest('dialog')) { /* follow the link; the page changes */ }
    var step = t.closest('[data-cyc-step]');
    if (step) { var li = step.closest('[data-cyc-line]'); var n = +li.querySelector('[data-cyc-qty]').value + +step.getAttribute('data-cyc-step'); setQty(li, Math.max(0, n)); return; }
    var rm = t.closest('[data-cyc-remove]'); if (rm) { setQty(rm.closest('[data-cyc-line]'), 0); return; }
    if (t.closest('[data-cyc-code-apply]')) { applyCode(root); return; }
    var rc = t.closest('[data-cyc-code-remove]'); if (rc) { removeCode(root, rc.getAttribute('data-cyc-code-remove')); return; }
    var go = t.closest('[data-cyc-checkout]');
    if (!go) return;
    go.classList.add('is-loading'); go.setAttribute('aria-busy', 'true');
    /* a quantity still saving: wait for it, then carry on to the cart page / checkout with the right cart */
    if (go.dataset.cycGo !== '1' && (Object.keys(pendingFn).length || root.classList.contains('is-busy'))) {
      e.preventDefault();
      settle().then(function () {
        go.dataset.cycGo = '1';
        if (go.tagName === 'A') location.href = go.href;
        else if (go.form && go.form.requestSubmit) go.form.requestSubmit(go);
        else go.click();
      });
    }
  }, true);
  document.addEventListener('change', function (e) {
    var inp = e.target.closest && e.target.closest('[data-cyc-qty]');
    if (inp) { var li = inp.closest('[data-cyc-line]'); setQty(li, Math.max(0, parseInt(inp.value, 10) || 0)); return; }
    var note = e.target.closest && e.target.closest('[data-cyc-note]');
    if (note) post('cart/update.js', { note: note.value }).then(function () { say('Note saved'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-cyc-code-input]')) { e.preventDefault(); applyCode(e.target.closest('[data-cyc-root]')); }
    trapTab(e);
  });
  function wireDialog() {
    var d = dialog(); if (!d || d.dataset.cycWired) return; d.dataset.cycWired = '1';
    d.addEventListener('close', onClosed);
    d.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
  }
  /* other code that changes the cart: the theme's events, a custom one, the back/forward cache */
  ['cart:update', 'cart:reload', 'cy:cart:refresh'].forEach(function (n) { document.addEventListener(n, function (e) { if (e && e.detail && e.detail.source === 'cy-cart') return; refetch(); }); });
  /* leaving the page closes the side cart at once, so Back (bfcache) returns to a clean page and the next open starts fresh */
  addEventListener('pagehide', function () { var d = dialog(); if (d && d.open) { d.classList.remove('is-in'); d.close(); } });
  addEventListener('pageshow', function (e) { document.querySelectorAll('[data-cyc-checkout].is-loading').forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); delete b.dataset.cycGo; }); if (e.persisted) refetch(); });

  /* the page's checkout dock: shown while the card's Checkout is off screen (phones) */
  var dockIO = null;
  function watchDock() {
    var page = document.querySelector('[data-cyc-root="page"]'); if (!page) return;
    var dock = page.querySelector('[data-cyc-dock]'), main = page.querySelector('[data-cyc-main-checkout]');
    if (!dock || !main || !('IntersectionObserver' in window)) return;
    if (dockIO) dockIO.disconnect();
    dockIO = new IntersectionObserver(function (en) { var vis = en[0].isIntersecting || en[0].boundingClientRect.top < 0; dock.hidden = vis || innerWidth > 989; });
    dockIO.observe(main);
  }

  /* Shopify's standard cart actions (where the storefront exposes them): apps open / refresh THIS cart */
  function configureShopify() {
    try {
      var A = window.Shopify && Shopify.actions;
      if (A && A.openCart && A.openCart.configure) A.openCart.configure({ handler: function () { open(); } });
    } catch (e) {}
  }

  function boot() { wireDialog(); watchDock(); configureShopify(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  window.cyCart = { open: open, close: close, refresh: refresh, add: add };
})();
